// Rocket Van Express Mock Data

export const CONTACT_INFO = {
  phone: '+27 736596239',
  whatsapp: '+27736596239',
  email: 'Info@rocketvan.co.za',
  operatingHours: 'Mon-Fri: 7:00 AM - 7:00 PM | Sat: 8:00 AM - 4:00 PM | Sun: Closed'
};

export const WHATSAPP_MESSAGES = {
  generic: 'Hi Rocket Van Express, I need a quote. Pickup: __ Drop-off: __ Items: __ Date/time: __',
  delivery: 'Hi Rocket Van Express, I need a DELIVERY quote. Pickup: __ Drop-off: __ Item: __ When: __',
  miniMove: 'Hi Rocket Van Express, I need a MINI-MOVE quote. Pickup: __ Drop-off: __ Photos: (sending) Helpers: __ Date/time: __',
  business: 'Hi Rocket Van Express, I\'d like a BUSINESS account. Company: __ Monthly deliveries: __ Areas: __ Email: __',
  track: 'Hi Rocket Van Express, I need to track my booking. Reference: RVE-'
};

export const SERVICE_TIERS = [
  {
    id: 'now',
    name: 'Rocket Van NOW',
    description: 'Urgent on-demand delivery',
    tagline: 'As fast as possible',
    icon: 'Zap'
  },
  {
    id: 'today',
    name: 'Rocket Van TODAY',
    description: 'Same-day scheduled delivery',
    tagline: 'Pickup window, deliver by EOD',
    icon: 'Clock'
  },
  {
    id: 'tomorrow',
    name: 'Rocket Van TOMORROW',
    description: 'Next-day scheduled',
    tagline: 'Best value option',
    icon: 'Calendar'
  }
];

export const TRUST_BADGES = [
  { icon: 'MessageCircle', text: 'Proactive WhatsApp updates' },
  { icon: 'Camera', text: 'Proof-of-delivery photos' },
  { icon: 'Heart', text: 'Care-first handling' },
  { icon: 'DollarSign', text: 'Transparent pricing' },
  { icon: 'MapPin', text: 'Local Western Cape knowledge' },
  { icon: 'CreditCard', text: 'Cashless-first option' }
];

export const SERVICES = [
  {
    id: 'deliveries',
    title: 'Deliveries',
    description: 'Small items & store pickups',
    icon: 'Package',
    benefits: [
      'Same-day & urgent options',
      'Real-time WhatsApp updates',
      'Photo proof-of-delivery'
    ],
    link: '/deliveries'
  },
  {
    id: 'mini-moves',
    title: 'Mini-Moves',
    description: 'Furniture & small removals',
    icon: 'Truck',
    benefits: [
      'Straps & blankets included',
      'Helper options available',
      'Care-first handling'
    ],
    link: '/mini-moves'
  },
  {
    id: 'business',
    title: 'Business Accounts',
    description: 'Monthly billing & priority',
    icon: 'Briefcase',
    benefits: [
      'Consolidated invoicing',
      'Priority dispatch',
      'Dedicated support'
    ],
    link: '/business'
  }
];

export const HOW_IT_WORKS = [
  {
    step: 1,
    title: 'Send pickup & drop-off pins',
    description: 'WhatsApp us your locations or use our quote form',
    icon: 'MapPin'
  },
  {
    step: 2,
    title: 'Get a quote in minutes',
    description: 'Clear pricing based on distance, load size & timing',
    icon: 'FileText'
  },
  {
    step: 3,
    title: 'Book & pay',
    description: 'Instant payment or monthly billing for business accounts',
    icon: 'CreditCard'
  },
  {
    step: 4,
    title: 'Updates + Proof-of-delivery',
    description: 'Live WhatsApp updates and delivery confirmation photos',
    icon: 'CheckCircle'
  }
];

export const AREAS_SERVED = {
  stellenbosch: ['Stellenbosch', 'Somerset West', 'Strand', 'Gordon\'s Bay'],
  helderberg: ['Somerset West', 'Strand', 'Gordon\'s Bay', 'Macassar'],
  northern: ['Bellville', 'Durbanville', 'Parow', 'Goodwood', 'Brackenfell'],
  southern: ['Muizenberg', 'Fish Hoek', 'Constantia', 'Wynberg', 'Claremont'],
  city: ['Cape Town CBD', 'Sea Point', 'Green Point', 'Woodstock', 'Observatory'],
  winelands: ['Paarl', 'Franschhoek', 'Wellington']
};

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Sarah M.',
    location: 'Stellenbosch',
    rating: 5,
    text: 'Quick response on WhatsApp, same-day delivery, and the driver was so professional. Will definitely use again!',
    service: 'Delivery'
  },
  {
    id: 2,
    name: 'David K.',
    location: 'Cape Town',
    rating: 5,
    text: 'Moved my furniture from Somerset West to Cape Town. They came with blankets and straps, very careful with everything.',
    service: 'Mini-Move'
  },
  {
    id: 3,
    name: 'Thandi N.',
    location: 'Paarl',
    rating: 5,
    text: 'Use them for my online store deliveries. Monthly billing makes it so easy, and customers love the fast service.',
    service: 'Business'
  }
];

export const FAQS = [
  {
    question: 'How is pricing calculated?',
    answer: 'Pricing depends on distance, load size, service tier (NOW/TODAY/TOMORROW), stairs/lift access, helpers needed, and any extra stops. We provide a clear quote before you book.'
  },
  {
    question: 'Can I get same-day delivery?',
    answer: 'Yes! Rocket Van TODAY offers same-day scheduled delivery, and Rocket Van NOW is for urgent on-demand delivery (subject to availability in your area).'
  },
  {
    question: 'What items can you move?',
    answer: 'Deliveries: small boxes, documents, marketplace pickups, store orders. Mini-Moves: furniture, appliances, multiple boxes. We can\'t move hazardous materials or items requiring specialized vehicles.'
  },
  {
    question: 'Do I need helpers for my mini-move?',
    answer: 'It depends on your load. Driver-only works for light items. We offer +1 or +2 helper options for heavy furniture, stairs, or large loads.'
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept EFT, card payments, and SnapScan. Business accounts get monthly invoicing with 7-day payment terms.'
  },
  {
    question: 'How does proof-of-delivery work?',
    answer: 'Our drivers take a photo and/or get a signature on delivery. You receive this via WhatsApp with a timestamp as proof.'
  },
  {
    question: 'Can I reschedule or cancel?',
    answer: 'Yes, contact us on WhatsApp as soon as possible. Cancellations within 2 hours of pickup may incur a fee.'
  },
  {
    question: 'What if something gets damaged?',
    answer: 'We handle items with care using straps and blankets. If damage occurs, report it immediately via WhatsApp with photos. We have a clear claims process.'
  }
];

export const BUSINESS_PACKAGES = [
  {
    name: 'Bronze',
    volume: '1-10 deliveries/month',
    features: [
      'Monthly consolidated invoicing',
      'Standard support (WhatsApp)',
      'Proof-of-delivery',
      '7-day payment terms'
    ]
  },
  {
    name: 'Silver',
    volume: '11-30 deliveries/month',
    features: [
      'Monthly consolidated invoicing',
      'Priority dispatch queue',
      'Proof-of-delivery',
      '14-day payment terms',
      'Dedicated account contact'
    ]
  },
  {
    name: 'Gold',
    volume: '31+ deliveries/month',
    features: [
      'Monthly consolidated invoicing',
      'Priority dispatch queue',
      'Proof-of-delivery',
      '30-day payment terms',
      'Dedicated account manager',
      'Custom service-level agreements'
    ]
  }
];
